import httpClient from "./_httpClient";

const END_POINT = "/import-settings";

const getCols = (scopeId) => httpClient.get(END_POINT + "/get-cols/" +scopeId);
const updateCols = (scopeId, colsData) => httpClient.put(END_POINT + '/put-cols/' + scopeId, colsData);

export {
  getCols,
  updateCols,
}
